"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vocabularyCourseWordKey = void 0;
const courseSortKey = (courseId) => `course#${courseId}`;
const vocabularyCourseWordKey = ({ wordId, courseId }) => ({
    wordId,
    sk: courseSortKey(courseId)
});
exports.vocabularyCourseWordKey = vocabularyCourseWordKey;
//# sourceMappingURL=VocabularyCourseWord.js.map